exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#secret-div[data-v-5d3c66cf]{color:#ccc}[dir] #secret-div[data-v-5d3c66cf]{border-style:solid;border-width:1px;border-radius:10px;padding:10px;margin-top:10%;margin-bottom:10%}[dir=ltr] #secret-div[data-v-5d3c66cf]{box-shadow:1px 1px 10px 2px;margin-left:25%}[dir=rtl] #secret-div[data-v-5d3c66cf]{box-shadow:-1px 1px 10px 2px;margin-right:25%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5d3c66cf","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/secret.vue
// module id = 989
// module chunks = 0